<template>
  <div id="app">
    <common-header v-show="isShow"></common-header>
    <scrollTop></scrollTop>

    <router-view> </router-view>

    <common-footer v-show="isShow"></common-footer>
  </div>
</template>

<script>
import commonHeader from '@/components/common/header'
import commonFooter from '@/components/common/footer'
import scrollTop from '@/components/common/scrollTop'

export default {
  created () {
    this.changeShow()
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'changeShow'
  },

  name: 'App',
  data: function () {
    return {
      isShow: true

    }
  },
  components: {
    commonHeader,
    commonFooter,
    scrollTop
  },
  methods: {
    changeShow () {
      if (this.$route.path === '/404' || this.$route.path === '/privacyPolicy' || this.$route.path === '/userAgreement') {
        this.isShow = false
      } else {
        this.isShow = true
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue